import script from "./CustomerOrderDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerOrderDetails.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerOrderDetails.vue?vue&type=style&index=0&id=35f2e51f&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f2e51f"]])

export default __exports__